import type { InjectionKey } from 'vue';
import { type OrderSections } from './types';

const visibleSectionsSymbol = Symbol('orderVisibleSectionsSymbol') as InjectionKey<OrderSections>;

export default visibleSectionsSymbol;
